var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"left-container"},[_c('logo')],1),_c('div',{staticClass:"right-container"},[(!_vm.isMobile)?_c('commercial'):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }